import React from 'react';
import { Button, ButtonProps, message } from 'antd';
import { getBillingPortalLink } from 'api/subscription';
import { ExportOutlined } from '@ant-design/icons';

type IProps = ButtonProps & {
    text?: string;
    hideIcon?: boolean;
};

const BillingPortalButton = (props: IProps) => {
    const {
        text = 'Billing and invoice details',
        hideIcon,
        ...reset } = props;
    const [loading, setLoading] = React.useState(false);
    return (
        <Button
            type="primary"
            {...reset}
            loading={loading}
            onClick={async () => {
                setLoading(true);
                const result = await getBillingPortalLink();
                if (!result.error) {
                    const link = result.data.data;
                    if (link) {
                        window.open(link, '_blank');
                    } else {
                        message.error('The customer billing portal is only available for paid users.');
                    }
                }

                setLoading(false);
            }}
        >
            {text}
            {
                !hideIcon && (
                    <ExportOutlined />
                )
            }
        </Button>
    );
};

export default BillingPortalButton;
